import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";

import { withRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import * as Constants from "./Constants";

const baseUrl = Constants.URL();

function SubscriptionConfirm({ match }) {
  const history = createBrowserHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [email, setEmail] = React.useState(match.params.email);

  const updateDetails = function () {
    const location = {
      pathname: `/UpdateDetails/email=${email.split("=")[1]}`,
      state: { fromDashboard: true },
    };

    history.push(location);

    window.location.reload();
  };

  return (
    <div className="Card u-marginAuto u-marginBottom20">
      <div className="Card-content u-marginTop10">
        <input
          className="customInput"
          type="hidden"
          name="csrfmiddlewaretoken"
          value="0aiY5RDRupxjz3ITP49uNZ3YYfET3oeBn3RewbVyTP1JNRJIwc6YRdCACn9UbrQr"
        />
        <h2 className="Card-title u-marginBottom20">Subscription Confirmed</h2>
        <p>Your subscription to the Vulekamali newsletter has been confirmed</p>
        <p>Thank you for subscribing!</p>

        <br />

        <a className="Button ButtonAutoWidth" href="https://vulekamali.gov.za/">
          Continue to our website
        </a>
        <br />

        <button className="Button" value="Unsubscribe" onClick={updateDetails}>
          Update Details
        </button>
      </div>
    </div>
  );
}

export default withRouter(SubscriptionConfirm);
